import { AxiosClient } from "./AxiosClient";

export const getAllPrompts = () => {
  try {
    return AxiosClient.post("topics/getAllPrompts", {});
  } catch (e) {
    console.log(e);
  }
};

export const deletePrompt = (prompt) => {
  try {
    return AxiosClient.post("topics/deletePrompt", { prompt });
  } catch (e) {
    console.log(e);
  }
};

export const addNewPrompt = (prompt) => {
  try {
    return AxiosClient.post("topics/addNewPrompt", { prompt });
  } catch (e) {
    console.log(e);
  }
};

// ******* CHAT *******************************************************************************************************

export const getCases = () => {
  try {
    return AxiosClient.get("cases/getCases");
  } catch (e) {
    console.log(e);
  }
};

export const getCaseUrl = (company_name) => {
  try {
    return AxiosClient.get("cases/getCaseUrl?company_name=" + company_name);
  } catch (e) {
    console.log(e);
  }
};

export const sendText = (
  question,
  chatThread,
  LLM,
  doc_ids,
  daysAgo,
  domain,
) => {
  try {
    return AxiosClient.post("chat/postNewChatMsg", {
      question,
      chatThread,
      LLM,
      doc_ids,
      daysAgo,
      domain,
    });
  } catch (e) {
    console.log(e);
  }
};

export const saveCase = (caseName, domain) => {
  try {
    return AxiosClient.post("cases/saveCase", { caseName, domain });
  } catch (e) {
    console.log(e);
  }
};

export const ttsRealtime = (text) => {
  try {
    return AxiosClient.post("chat/ttsRealtime", { text });
  } catch (e) {
    console.log(e);
  }
};

export const activateCase = (caseName, activate) => {
  try {
    return AxiosClient.post("cases/activateCase", { caseName, activate });
  } catch (e) {
    console.log(e);
  }
};

export const deleteCase = (caseName) => {
  try {
    return AxiosClient.post("cases/deleteCase", { caseName });
  } catch (e) {
    console.log(e);
  }
};

export const getLastCaseConversations = (uuid) => {
  try {
    return AxiosClient.get("chat/getLastCaseConversations?currentCase=" + uuid);
  } catch (e) {
    console.log(e);
  }
};

export const getLastCaseConversationsExplorer = (caseName) => {
  try {
    return AxiosClient.get(
      "chat/getLastCaseConversationsExplorer?currentCase=" + caseName,
    );
  } catch (e) {
    console.log(e);
  }
};

export const updateQaDislike = (thumb, document_id) => {
  try {
    return AxiosClient.post("chat/updateQaDislike", { thumb, document_id });
  } catch (e) {
    console.log(e);
  }
};

export const updateQaLike = (thumb, document_id) => {
  try {
    return AxiosClient.post("chat/updateQaLike", { thumb, document_id });
  } catch (e) {
    console.log(e);
  }
};

export const updateQaCatalog = (document_id) => {
  try {
    return AxiosClient.post("chat/updateQaCatalog", { document_id });
  } catch (e) {
    console.log(e);
  }
};

export const getFlatFileDocs = () => {
  try {
    return AxiosClient.get("chat/getFlatFileDocs");
  } catch (e) {
    console.log(e);
  }
};

export const getDocsbyIds = (doc_ids) => {
  try {
    return AxiosClient.get("chat/getDocsbyIds?doc_ids=" + doc_ids);
  } catch (e) {
    console.log(e);
  }
};

export const getLastExplorerGraph = (document_id) => {
  try {
    return AxiosClient.get(
      "chat/getLastExplorerGraph?document_id=" + document_id,
    );
  } catch (e) {
    console.log(e);
  }
};

//  *********************************************************************************************************************

export const getThreads = (offset, thread_type = "", search = "") => {
  try {
    let url = "chat/getThreads?offset=" + offset;
    if (thread_type) url += "&thread_type=" + thread_type;
    if (search) url += "&search=" + encodeURIComponent(search);
    return AxiosClient.get(url, { useCompany: true });
  } catch (e) {
    console.log(e);
  }
};

export const createThread = (
  thread_id,
  prompt,
  type,
  userTime,
  thread_type = "private",
  model = "",
) => {
  try {
    return AxiosClient.post(
      "chat/createThread",
      {
        thread_id,
        prompt,
        type,
        userTime,
        thread_type,
        model,
      },
      { useCompany: true },
    );
  } catch (e) {
    console.log(e);
  }
};

export const uploadFile = (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    return AxiosClient.post("chat/fileUpload", formData);
  } catch (e) {
    console.log(e);
  }
};

// ******* PUBLIC CHAT (LiteLLM) ******************************************************************************************************

export const getEnabledPublicModels = () => {
  try {
    return AxiosClient.get("settings/getEnabledPublicModels");
  } catch (e) {
    console.log(e);
  }
};

export const savePublicCitation = ({
  url,
  title,
  domain,
  content,
  description,
  og_image,
  direction,
}) => {
  try {
    return AxiosClient.post("chat/savePublicCitation", {
      url,
      title,
      domain,
      content,
      description,
      og_image,
      direction,
    });
  } catch (e) {
    console.log(e);
  }
};

export const scrapePublicCitation = ({ url }) => {
  try {
    return AxiosClient.post("chat/scrapePublicCitation", { url });
  } catch (e) {
    console.log(e);
  }
};

export const renameThread = ({ thread_id, title }) => {
  try {
    return AxiosClient.post("chat/renameThread", { thread_id, title });
  } catch (e) {
    console.log(e);
  }
};

export const deleteThread = ({ thread_id }) => {
  try {
    return AxiosClient.post("chat/deleteThread", { thread_id });
  } catch (e) {
    console.log(e);
  }
};

export const batchDeleteThreads = ({ thread_ids }) => {
  try {
    return AxiosClient.post("chat/batchDeleteThreads", { thread_ids });
  } catch (e) {
    console.log(e);
  }
};
